import type { ReactNode } from 'react';
import { dash } from '../lib/display';

/**
 * A content panel.
 *
 * NOTE ON THE MISSING "Edit" BUTTONS. The prototype puts an `Edit` action in
 * several panel headers, and `+ Add facility`, `Download list`, `Management
 * overview`, `Edit info` and `+ Add vendor` elsewhere. None of them are
 * rendered here, deliberately.
 *
 * FacilityWISE v1 is read-only end to end: the facility master lives on
 * WPICSQL2502 and this module reaches it as the `ChaunceyAI` login, which has no
 * write rights. Shipping a button that cannot do anything to real users in
 * production is a false affordance — someone clicks it, nothing happens, and
 * they stop trusting the screens that DO work. The buttons come back in the
 * release that ships a write path, not before.
 */
export function Panel({
  title,
  count,
  children,
  footer,
}: {
  title: string;
  count?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <section className="pnl">
      <div className="pnl-h">
        <h3>{title}</h3>
        {count !== undefined && <span className="pnl-n">{count}</span>}
      </div>
      {children}
      {footer && <div className="pnl-foot">{footer}</div>}
    </section>
  );
}

export type KVRow = [string, ReactNode];

export function KeyValue({ rows }: { rows: KVRow[] }) {
  return (
    <div className="kv">
      {rows.map(([k, v]) => (
        <div className="kvr" key={k}>
          <dt>{k}</dt>
          <dd>{dash(v)}</dd>
        </div>
      ))}
    </div>
  );
}

export function Mono({ children }: { children: ReactNode }) {
  return <span className="mono">{children}</span>;
}
